var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "divBox" },
    [
      _c("el-card", { attrs: { bordered: false, shadow: "never" } }, [
        _c(
          "div",
          { staticClass: "padding-add" },
          [
            _c(
              "el-form",
              {
                attrs: { inline: "", size: "small", "label-position": "right" },
                nativeOn: {
                  submit: function ($event) {
                    $event.preventDefault()
                  },
                },
              },
              [
                _c(
                  "el-form-item",
                  { attrs: { label: "用户ID：" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入用户ID", clearable: "" },
                      model: {
                        value: _vm.queryParams.userId,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "userId", $$v)
                        },
                        expression: "queryParams.userId",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  { attrs: { label: "任务名称：" } },
                  [
                    _c("el-input", {
                      attrs: { placeholder: "请输入任务名称", clearable: "" },
                      model: {
                        value: _vm.queryParams.taskName,
                        callback: function ($$v) {
                          _vm.$set(_vm.queryParams, "taskName", $$v)
                        },
                        expression: "queryParams.taskName",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "el-form-item",
                  [
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:task:userlog:list"],
                            expression: "['platform:task:userlog:list']",
                          },
                        ],
                        attrs: { type: "primary" },
                        on: { click: _vm.handleQuery },
                      },
                      [_vm._v("搜索")]
                    ),
                    _c(
                      "el-button",
                      {
                        directives: [
                          {
                            name: "hasPermi",
                            rawName: "v-hasPermi",
                            value: ["platform:task:userlog:list"],
                            expression: "['platform:task:userlog:list']",
                          },
                        ],
                        on: { click: _vm.resetQuery },
                      },
                      [_vm._v("重置")]
                    ),
                  ],
                  1
                ),
              ],
              1
            ),
          ],
          1
        ),
      ]),
      _c(
        "el-card",
        {
          staticClass: "table-card mt14",
          attrs: { "body-style": { padding: "20px" } },
        },
        [
          _c(
            "el-table",
            {
              directives: [
                {
                  name: "loading",
                  rawName: "v-loading",
                  value: _vm.loading,
                  expression: "loading",
                },
              ],
              staticStyle: { width: "100%" },
              attrs: { data: _vm.logList, size: "small", border: "" },
            },
            [
              _c("el-table-column", {
                attrs: {
                  prop: "userId",
                  label: "用户ID",
                  align: "center",
                  width: "100",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "taskName",
                  label: "任务名称",
                  align: "center",
                  "min-width": "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "rewardPoints",
                  label: "获得积分",
                  align: "center",
                  width: "120",
                },
              }),
              _c("el-table-column", {
                attrs: {
                  prop: "createTime",
                  label: "完成时间",
                  align: "center",
                  width: "180",
                },
              }),
            ],
            1
          ),
          _c("el-pagination", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.total > 0,
                expression: "total > 0",
              },
            ],
            attrs: {
              total: _vm.total,
              "current-page": _vm.queryParams.page,
              "page-size": _vm.queryParams.limit,
              "page-sizes": [20, 30, 50],
              layout: "total, sizes, prev, pager, next, jumper",
            },
            on: {
              "update:currentPage": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:current-page": function ($event) {
                return _vm.$set(_vm.queryParams, "page", $event)
              },
              "update:pageSize": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              "update:page-size": function ($event) {
                return _vm.$set(_vm.queryParams, "limit", $event)
              },
              "size-change": _vm.getList,
              "current-change": _vm.getList,
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }